import React, { Component } from 'react';
import { Card, Col, Row, Button } from 'reactstrap';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

class ProceduresTemplateMulti extends Component {

    constructor() {
        super();
        this.state = {
            typeProcedure: true,
            containTemplate: "",
            nameTemplate: "",
            templatesProcedures: [],
            idTemplateProcedure: null
        }
    }

    componentDidMount = () => {
        this.getTemplates();
    }

    handlerTemplateProcedures = (value) => {

        let template = this.state.templatesProcedures.find(temp => temp.id_historia_plantilla_procedimientos == value);

        if (template != null) {
            this.setState({
                containTemplate: template.contenido,
                idTemplateProcedure: template.id_historia_plantilla_procedimientos,
                nameTemplate: template.plantilla,
                typeProcedure: template.tipo
            });
        }
        else {
            this.setState({
                containTemplate: "",
                idTemplateProcedure: null,
                nameTemplate: "",
                typeProcedure: null
            });
        }

    }

    handlerTypeProcedure = (value) => {
        this.setState({ typeProcedure: value });
    }

    handlerContainTemplate = (value) => {
        this.setState({ containTemplate: value });
    }

    handlerNameTemplate = (value) => {
        this.setState({ nameTemplate: value });
    }

    saveTemplate = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'historia-plantillas-procedimientos/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
                plantilla: this.state.nameTemplate,
                tipo: this.state.typeProcedure,
                contenido: this.state.containTemplate
            })
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error('Data');
            }
        }).then(response => {
            this.callBack();
        }).catch(err => {
            alert("Ha ocurrido un error creando la Plantilla");
            console.log(err);
        });
    }

    updateTemplate = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'historia-plantillas-procedimientos/update', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
                id_historia_plantilla_procedimientos: this.state.idTemplateProcedure,
                plantilla: this.state.nameTemplate,
                tipo: this.state.typeProcedure,
                contenido: this.state.containTemplate
            })
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error('Data');
            }
        }).then(response => {
            this.callBack();
        }).catch(err => {
            alert("Ha ocurrido un error actualizando la Plantilla");
            console.log(err);
        });
    }

    deleteTemplate = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'historia-plantillas-procedimientos/delete', {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
                id_historia_plantilla_procedimientos: this.state.idTemplateProcedure
            })
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                this.callBack();
            }
            else {
                throw new Error('Data');
            }
        }).catch(err => {
            alert("Ha ocurrido un error eliminando la Plantilla");
            console.log(err);
        });
    }
 
    getTemplates = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'historia-plantillas-procedimientos/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error('Data');
            }
        }).then(data => {

            console.log("dataPlantilla", data);
            this.setState({ templatesProcedures: data });
        }).catch(err => {
            console.log(err);
        });
    }

    callBack = () => {
        this.getTemplates().then(() => {
            this.setState({
                containTemplate: "",
                idTemplateProcedure: null,
                nameTemplate: "",
                typeProcedure: null
            });
        });
    }

    render() {
        return (
            <Card>
                <div className="form" style={{ flex: 1, flexDirection: 'column', display: 'flex' }}>
                    <div className="card__title">
                        <h5 className="bold-text">Plantillas de Procedimientos</h5>
                    </div>
                </div>
                <br />
                <div>

                    <Row>
                        <Col md={4}>
                            <TextField
                                id="txtPlantilla"
                                label="Plantilla"
                                select
                                value={this.state.idTemplateProcedure}
                                className='medical-material-form__field'
                                onChange={(event) => {
                                    this.handlerTemplateProcedures(event.target.value);
                                }}
                                InputLabelProps={{
                                    style: { color: '#646777' },
                                    shrink: this.state.typeProcedure != null ? true : false
                                }}
                                style={{ minWidth: '100%', maxWidth: '100%' }}
                            >
                                <MenuItem key={0} value={null}>
                                    Ninguna
                                </MenuItem>
                                {this.state.templatesProcedures.map((templateProcedure) => {
                                    return <MenuItem key={templateProcedure.id_historia_plantilla_procedimientos} value={templateProcedure.id_historia_plantilla_procedimientos}>
                                        {templateProcedure.plantilla}
                                    </MenuItem>
                                })}
                            </TextField>
                        </Col>
                        <Col md={4}>
                            <TextField
                                id="txtNombrePlantilla"
                                label="Nombre de la Plantilla"
                                value={this.state.nameTemplate}
                                className='medical-material-form__field'
                                type='text'
                                onChange={(event) => {
                                    this.handlerNameTemplate(event.target.value);
                                }}
                                InputLabelProps={{
                                    style: { color: '#646777' },
                                    shrink: this.state.nameTemplate != null && this.state.nameTemplate != "" ? true : false
                                }}
                                style={{ minWidth: '100%', maxWidth: '100%' }}
                            />
                        </Col>
                        <Col md={4}>
                            <TextField
                                id="txtTypeProcedure"
                                label="Tipo de Procedimiento"
                                select
                                value={this.state.typeProcedure}
                                disabled={this.state.idTemplateProcedure != null ? true : false}
                                className='medical-material-form__field'
                                onChange={(event) => {
                                    this.handlerTypeProcedure(event.target.value);
                                }}
                                InputLabelProps={{
                                    style: { color: '#646777' },
                                    shrink: this.state.typeProcedure != null ? true : false
                                }}
                                style={{ minWidth: '100%', maxWidth: '100%' }}
                            >
                                <MenuItem key={1} value={1}>
                                    ECO
                                </MenuItem>
                                <MenuItem key={2} value={2}>
                                    EKG
                                </MenuItem>
                                <MenuItem key={3} value={3}>
                                    STRESS
                                </MenuItem>
                                <MenuItem key={4} value={4}>
                                    TEST
                                </MenuItem>
                                <MenuItem key={5} value={5}>
                                    LABORATORIO
                                </MenuItem>
                                <MenuItem key={6} value={6}>
                                    HOLTER
                                </MenuItem>
                                <MenuItem key={7} value={7}>
                                    MAPA
                                </MenuItem>
                            </TextField>
                        </Col>
                    </Row>

                    <br /><br />

                    <CKEditor
                        style={{ width: '100%', height: '200px' }}
                        editor={ClassicEditor}
                        data={this.state.containTemplate}
                        onChange={(event, editor) => {
                            const data = editor.getData();
                            this.setState({
                                containTemplate: data
                            })
                        }}
                    />

                    <br /><br />

                    {
                        this.state.idTemplateProcedure == null ?
                            <>
                                <Button
                                    color="primary"
                                    onClick={() => {
                                        this.saveTemplate();
                                    }}
                                >
                                    Crear
                                </Button>
                            </> : <>
                                <Button
                                    color="primary"
                                    onClick={() => {
                                        this.updateTemplate();
                                    }}
                                >
                                    Actualizar
                                </Button>
                                <Button
                                    color="danger"
                                    onClick={() => {
                                        this.deleteTemplate();
                                    }
                                }
                                >
                                    Eliminar
                                </Button>
                            </>
                    }

                </div>
            </Card>
        );
    }
}

export default ProceduresTemplateMulti;